import { Dropdown, DropdownProps } from './Dropdown/Dropdown';
import { Horizontal } from './Horizontal/Horizontal';
import { HorizontalListOptionType } from './_components/List/List';

const Selector = {
	Horizontal,
	Dropdown,
};

export { Selector, type HorizontalListOptionType, type DropdownProps };
